import { useEffect, useRef } from 'react';

export const DpJS = ({ inner, nonce }: { inner: string; nonce?: string }) => {
	const scriptRef = useRef<HTMLScriptElement | null>(null);

	useEffect(() => {
		if (!inner) return;

		const script = document.createElement('script');
		script.id = `dpjs-inline-${Date.now()}`;
		script.type = 'text/javascript';
		if (nonce) {
			script.nonce = nonce;
		}

		script.textContent = inner;

		document.body.appendChild(script);
		scriptRef.current = script;

		return () => {
			if (scriptRef.current && scriptRef.current.parentNode) {
				scriptRef.current.parentNode.removeChild(scriptRef.current);
				scriptRef.current = null;
			}
		};
	}, []);

	return null;
};
